<template>
  <div class="inquiry-form-page">
    <!-- form -->
    <el-form
      ref="form"
      class="custom-form form"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <el-form-item label="票号" prop="billno">
            <el-input
              v-model="form.billno"
              suffix-icon="el-icon-c-scale-to-original"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <el-form-item label="承兑人名称" prop="acceptorName">
            <el-input
              v-model="form.acceptorName"
              suffix-icon="el-icon-user"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <el-form-item label="票面金额" prop="billAmount">
            <el-input
              v-model="form.billAmount"
              suffix-icon="el-icon-s-finance"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <el-form-item label="到期日期" prop="endDate">
            <el-date-picker
              v-model="form.endDate"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" class="submit-line">
          <el-button
            type="primary"
            class="submit-button"
            @click="submit"
            :loading="loading"
          >
            立即询价
          </el-button>
          <el-button type="default" class="upload" @click="openScan">
            图片识别
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <!-- 智能填写 -->
    <upload-cropper
      ref="uploadCropper"
      @on-success="uploadSuccess"
    ></upload-cropper>
    <!-- result -->
    <div class="result-wrapper">
      <!-- data -->
      <div class="result" v-if="showData">
        <h4 class="title">询价结果</h4>
        <card :data="result"></card>
        <div class="oper">
          <el-button
            type="primary"
            v-if="showData"
            @click="apply"
            :disabled="!applyable || applyRefused"
            >申报订单</el-button
          >
        </div>
        <!-- 申报提示 -->
        <el-alert
          class="apply-info"
          type="warning"
          :closable="false"
          v-if="!applyable"
        >{{ refuseApplyMsg }}</el-alert
        >
      </div>
      <!-- no data -->
      <div class="no-data" v-if="false">
        <img :src="assets.noData" alt="" />
        <p class="text">暂无数据</p>
      </div>
    </div>
    <!-- 移动端提示 -->
    <mobile-dialog ref="mobileDialog"></mobile-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { checkToken, uploadTransferBaseParam } from "@/libs/tools";
import { moneyPattern, validateFileType } from "@/libs/formValidate";
import OrderCard from "@/components/OrderCard/Card2";
import UploadCropper from "@/components/Cropper/";
import MobileDialog from "@/components/MobileDialog";

export default {
  components: {
    card: OrderCard,
    "upload-cropper": UploadCropper,
    "mobile-dialog": MobileDialog
  },
  data() {
    return {
      assets: {
        noData: require("@/assets/img/icons/no-data.png")
      },
      form: {
        billno: "",
        acceptorName: "",
        billAmount: "",
        endDate: ""
      },
      rules: {
        acceptorName: [
          {
            required: true,
            message: "请输入承兑人名称",
            trigger: "change"
          }
        ],
        billAmount: [
          {
            required: true,
            message: "请输入票面金额",
            trigger: "change"
          },
          {
            pattern: moneyPattern(),
            message: "请输入正确的格式",
            trigger: "change"
          }
        ],
        endDate: [
          {
            required: true,
            message: "请选择到期时间",
            trigger: "change"
          }
        ]
      },
      ocr: {},
      error: "",
      searched: true,
      result: {},
      loading: false,
      // 是否可申报
      applyable: true,
      applyRefused: false,
      refuseApplyMsg: ""
    };
  },
  computed: {
    ...mapGetters(["getUsername", "getToken", "isMobile"]),
    tipMessage() {
      return this.error || "暂无结果";
    },
    showData() {
      return Object.keys(this.result).length !== 0;
    }
  },
  async created() {
    // this.mockData();
    this.applyable = await this.checkWorkDate();
  },
  methods: {
    // 检查是否支持申报（外部接口-废弃）
    checkWorkDateInternet() {
      return new Promise(resolve => {
        const limitHour = [9, 17];

        const now = new Date();
        const hours = now.getHours();
        const date =
          "" + now.getFullYear() + (now.getMonth() + 1) + now.getDate();

        const appKey = "62941";
        const sign = "78d630eb3796f6f51d74f12aa55c8dd1";
        const url = `http://api.k780.com/?app=life.workday&date=${date}&appkey=${appKey}&sign=${sign}&format=json`;

        axios.get(url).then(res => {
          const { data } = res;
          const { result } = data || {};
          const { worknm } = result || {};

          if (worknm === "假日") {
            resolve(false);
            return;
          }

          // if (hours >= limitHour[0] && hours < limitHour[1]) {
          //   console.log('未下班')
          // } else {
          //   console.log('下班')
          // }
          resolve(hours >= limitHour[0] && hours < limitHour[1]);
        });
      });
    },

    checkWorkDate() {
      return new Promise(resolve => {
        this.$request.common_checkWorkDay().then(res => {
          const { workStatus = false, statusMsg = "" } = res || {};

          // 非工作日 || 工作日非工作时间
          if (!workStatus) {
            this.refuseApplyMsg = statusMsg;
            resolve(false);
            return;
          }

          // 工作日且工作时间
          this.refuseApplyMsg = "";
          resolve(true);
        });
      });
    },

    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;

        const param = {
          ...this.form,
          agentType: this.isMobile ? "1" : "0"
        };
        delete param["billno"];

        this.$request.inquiry_ask(param).then(res => {
          const { code = -1, msg = "", queryRes = {} } = res;

          this.loading = false;
          this.searched = false;
          this.result = queryRes;

          if (code !== 0) {
            this.applyRefused = true;
            this.error = msg;
            return;
          }

          const { status = -1, refusereason = "" } = queryRes;
          this.error = "";

          // 授信失败
          if (status === -1) {
            this.applyRefused = true;
            this.error = refusereason;
            this.$refs.mobileDialog.show("error");
            return;
          }

          this.applyRefused = false;
        });
      });
    },

    beforeUpload(file) {
      // 验证格式
      if (!validateFileType(file, ["png", "jpeg", "image/jpeg", "image/png"]))
        return false;
      this.loading = true;
    },

    validateMobileOperation() {
      this.isMobile && this.$refs.mobileDialog.show("info");
      return this.isMobile;
    },

    openScan() {
      // 移动端不可用
      if (this.validateMobileOperation()) return;
      this.$refs.uploadCropper.showModal();
    },

    // ocr识别成功
    uploadSuccess(res) {
      // const { code = -1, msg = "", billMap = {} } = res;
      //
      // this.loading = false;
      // this.searched = false;
      //
      // if (code !== 0) {
      //   this.ocr = {};
      //   this.error = msg;
      //   return;
      // }

      const { billno, acceptor, amount, enddate } = res;

      this.form.billno = billno;
      this.form.acceptorName = acceptor;
      this.form.billAmount = amount;
      this.form.endDate = enddate;

      this.ocr = res || {};
    },

    // 申请
    async apply() {
      // 移动端不可用
      if (this.validateMobileOperation()) return;

      // 是否登录
      const authValid = await checkToken();
      if (!authValid) {
        this.$refs.mobileDialog.show("infoPC");
        return;
      }

      // 工作日验证
      this.applyable = await this.checkWorkDate();
      if (!this.applyable) return;

      // 参数拼装
      let param = { ...this.result };
      let paramStr = "";

      if (this.form.billno === this.ocr["billno"]) {
        // ocr返回字段
        // const { acceptor, amount, billno, collector, drawer, enddate, issuedate } = this.ocr;
        // 询价结果返回字段
        // const { acceptor, billamount, creditamount, entname, loanamount, repaydate, status, yearrate } = this.ocr;
        param = {};
        param = {
          ...this.ocr,
          ...this.result
        };
      }

      // 字段名统一
      param["amount"] = param["amount"] ? param["amount"] : param["billamount"];
      delete param["billamount"];
      delete param["status"];

      Object.keys(param).forEach(k => (paramStr += `&${k}=${param[k]}`));

      const url = await uploadTransferBaseParam(paramStr);
      window.open(url, "_target");
    },

    clear() {
      this.$refs.form.resetFields();
    },

    mockData() {
      this.form.billno = "231319100057220210302867128061";
      this.form.acceptorName = "庆安集团有限公司";
      this.form.billAmount = "1000";
      this.form.endDate = "2022-11-11";
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/pages/inquiry.scss";
</style>
